import Covid from "./Covid";

import "./styles.scss";

export default {
  Covid,
};
